import { IconButton } from "@material-ui/core";
import { GridApi, GridCellParams, GridCellValue, GridColDef } from "@material-ui/data-grid";
import { MdDelete, MdEdit } from "react-icons/md";
import { prettyDate } from "../config/dateFormatting";

export const data_grid_eater_bookings_columns: GridColDef[] = [
    { field: 'eaterName', headerName: 'Booked by', flex: 1 },
    { field: 'seatingStart', headerName: 'Seating time', flex: 1 },
    { field: 'seatingTime', headerName: 'Seating time', flex: 1 },
    { field: 'seatingName', headerName: 'Seating name', flex: 1 },
    { field: 'totalNoPeople', headerName: 'No. people', flex: 1 },
    { field: 'bookingPricePerServing', headerName: 'Price per servering', flex: 1 },
]

export const data_grid_admin_users_column: GridColDef[] = [
    { field: 'createdAt', headerName: 'Created At', flex: 1,
    renderCell: (params: GridCellParams) => {
        return (
            prettyDate(params.getValue(params.id,"createdAt") as string,true,true)
        )} 
    },
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'email', headerName: 'Email', flex: 1 },
    { field: 'eaterGroupName', headerName: 'Eater Group', flex: 1 },
    { field: 'status', headerName: 'Status', flex: 1 },
]

export const data_grid_bookings_columns = (editBooking: (id: string) => void, deleteBooking: (id: string) => void): GridColDef[] => [
    { field: 'seatingStart', headerName: 'Seating date', flex: 1,
    renderCell: (params: GridCellParams) => {
        return (
            prettyDate(params.getValue(params.id,"seatingStart") as string,true,true)
        )} 
    },
    { field: 'eaterName', headerName: 'Booked by', flex: 1 },
    { field: 'seatingName', headerName: 'Seating name', flex: 1 },
    { field: 'totalNoPeople', headerName: 'No. people', flex: 1 },
    { field: 'comment', headerName: 'Comment', flex: 1 },
    {   field: 'edit',
        headerName: 'Edit',
        sortable: false,
        renderCell: (params: GridCellParams) => {
            return (
                <IconButton onClick={() => editBooking(params.id.toString())}>
                    <MdEdit />
                </IconButton>
            )
        }
    },
    {   
        field: 'delete',
        headerName: 'Delete',
        sortable: false,
        renderCell: (params: GridCellParams) => {
        return (
            <IconButton onClick={() => deleteBooking(params.id.toString())}>
                <MdDelete />
            </IconButton>
        )
    }
},
]

export const data_grid_eater_group_users_columns: GridColDef[] = [
    { field: 'name', headerName: 'Eater name', flex: 1 },
    { field: 'role', headerName: 'Role', flex: 1 },
    {  field: 'delete',
        headerName: 'Delete',
        sortable: false,
        renderCell: (params: GridCellParams) => {
            const onClick = (e: any) => {
                e.stopPropagation(); // don't select this row after clicking
        
                const api: GridApi = params.api;
                const thisRow: Record<string, GridCellValue> = {};
        
                api
                  .getAllColumns()
                  .filter((c) => c.field !== '__check__' && !!c)
                  .forEach(
                    (c) => (thisRow[c.field] = params.getValue(params.id, c.field)),
                  );
        
                return alert(JSON.stringify(thisRow, null, 4));
              };

            return (
                <IconButton>
                    <MdDelete />
                </IconButton>
            )
        }
    },
]

export const data_grid_eater_group_bookings_columns: GridColDef[] = [
    { field: 'eaterName', headerName: 'Booked by', flex: 1 },
    { field: 'seatingStart', headerName: 'Time', width: 200,
        renderCell: (params: GridCellParams) => {
            return (
                prettyDate(params.getValue(params.id,"seatingStart") as string,true,true)
            )
        } 
    },
    { field: 'seatingName', headerName: 'Name', flex: 1 },
    { field: 'totalNoPeople', headerName: 'Total No. people', flex: 1 },
    { field: 'bookingPricePerServing', headerName: 'Price per servicing', flex: 1 },   
]
